import { useMutation } from "@tanstack/react-query";
import {
  type InitiateTransactionResponse,
  postTransactionsInitiate,
  type ErrorResponse,
  type InitiateTransactionRequest,
} from "Infrastructure/Api/Api";
import { processResponseWithApiProblemDetails } from "Infrastructure/Api/ApiUtils";

type Props = {
  onSuccess?: (publicID: InitiateTransactionResponse) => void;
  onError?: (
    error: ErrorResponse,
    variables: InitiateTransactionRequest,
  ) => void;
};

export const useTransactionInitiateMutation = ({
  onSuccess,
  onError,
}: Props = {}) =>
  useMutation({
    mutationFn: processResponseWithApiProblemDetails(postTransactionsInitiate),
    onSuccess,
    onError,
  });
